import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import styled from "styled-components";
import moment from "moment";

export default function CalendarComp({
  outLine,
  height,
  value,
  onChange,
  maxDate,
  minDate,
  events = [],
  onDateClick,
}) {
  // Helper function to check if a date has events
  const getEventsForDate = (date) => {
    if (!events || events.length === 0) return [];
    const dateStr = moment(date).format("YYYY-MM-DD");
    return events.filter((event) => {
      const startDate = moment(event.start_date).format("YYYY-MM-DD");
      const endDate = moment(event.end_date).format("YYYY-MM-DD");
      return moment(dateStr).isBetween(startDate, endDate, null, "[]");
    });
  };

  // Helper function to check if date is start of event
  const isEventStart = (date, event) => {
    const dateStr = moment(date).format("YYYY-MM-DD");
    const startDate = moment(event.start_date).format("YYYY-MM-DD");
    return dateStr === startDate;
  };

  // Helper function to check if date is end of event
  const isEventEnd = (date, event) => {
    const dateStr = moment(date).format("YYYY-MM-DD");
    const endDate = moment(event.end_date).format("YYYY-MM-DD");
    return dateStr === endDate;
  };

  // Custom tile content to display events
  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;

    const dateEvents = getEventsForDate(date);
    if (dateEvents.length === 0) return null;

    // Show up to 2 events, then "+ X More"
    const maxVisible = 2;
    const visibleEvents = dateEvents.slice(0, maxVisible);
    const remainingCount = dateEvents.length - maxVisible;

    return (
      <EventTileContent>
        {visibleEvents.map((event, index) => {
          const isStart = isEventStart(date, event);
          const isEnd = isEventEnd(date, event);
          const isMultiDay =
            moment(event.end_date).diff(moment(event.start_date), "days") > 0;

          return (
            <EventItem
              key={`${event.id}-${index}`}
              onClick={(e) => {
                e.stopPropagation();
                if (onDateClick) {
                  onDateClick(date, dateEvents);
                }
              }}
              isStart={isStart}
              isEnd={isEnd}
              isMultiDay={isMultiDay}
              className="event-item"
            >
              {isStart && (
                <EventTitle>{event.name || "Untitled Event"}</EventTitle>
              )}
              {!isStart && isMultiDay && <EventBar />}
            </EventItem>
          );
        })}
        {remainingCount > 0 && (
          <MoreEventsIndicator
            onClick={(e) => {
              e.stopPropagation();
              if (onDateClick) {
                onDateClick(date, dateEvents);
              }
            }}
          >
            +{remainingCount} More
          </MoreEventsIndicator>
        )}
      </EventTileContent>
    );
  };

  // Custom tile class name for dates with events
  const tileClassName = ({ date, view }) => {
    if (view !== "month") return null;
    const dateEvents = getEventsForDate(date);
    if (dateEvents.length > 0) {
      return "has-events";
    }
    return null;
  };

  return (
    <CalendarStyle Height={height}>
      <div className={`${outLine ? "" : "Wrapper"}  font-1`}>
        <Calendar
          selectRange={false}
          value={value || new Date()}
          onChange={onChange}
          maxDate={maxDate}
          minDate={minDate}
          tileContent={tileContent}
          tileClassName={tileClassName}
          onClickDay={onDateClick ? (value) => {
            const dateEvents = getEventsForDate(value);
            onDateClick(value, dateEvents);
          } : undefined}
        />
      </div>
    </CalendarStyle>
  );
}
// export default function CalendarComp({outLine,height}) {
//   return (
//     <div Height={height}>
//              <CalendarComponent></CalendarComponent>

//     </div>
//   )
// }

const CalendarStyle = styled.div`
  display: flex;
  justify-content: center;
  .Wrapper {
    box-shadow: -2px -2px 10px rgba(0, 0, 0, 0.05),
      2px 2px 10px rgba(0, 0, 0, 0.05);
    padding: 10px;
    border-radius: 20px;
    display: inline-block;
  }
  /* Current date (today) - always visible with border and shadow for better visibility */
  .react-calendar__tile--now {
    background: var(--color-primary) !important;
    color: white !important;
    font-weight: bold !important;
    border: 2px solid var(--color-primary) !important;
    box-shadow: 0 0 0 1px rgba(139, 49, 58, 0.3) !important;
  }
  /* Current date when selected - keep it visible */
  .react-calendar__tile--now.react-calendar__tile--active {
    background: var(--color-primary) !important;
    color: white !important;
    font-weight: bold !important;
    border: 2px solid var(--color-primary) !important;
  }
  /* Current date when hovered - keep it visible */
  .react-calendar__tile--now:hover {
    background: var(--color-primary) !important;
    color: white !important;
    opacity: 0.9;
    border: 2px solid var(--color-primary) !important;
  }
  /* Selected date styling (different from today) */
  .react-calendar__tile--active {
    background: var(--color-secondary) !important;
    color: white !important;
  }
  .react-calendar__tile--active:not(.react-calendar__tile--now) {
    background: var(--color-secondary) !important;
    color: white !important;
  }
  .react-calendar {
    border: none;
    width: auto !important;
    height: ${(props) => (props?.Height ? props?.Height : "100%")};
  }
  /* Calendar navigation buttons */
  .react-calendar__navigation button {
    font-size: 18px !important;
    font-weight: 600 !important;
    min-width: 44px !important;
    min-height: 44px !important;
  }
  /* Calendar month/year label */
  .react-calendar__navigation__label {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
  .react-calendar__month-view__weekdays div abbr {
    text-decoration: none !important;
    font-family: "Work Sans", sans-serif !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .react-calendar__month-view__days {
    font-family: "Work Sans", sans-serif !important;
    font-size: 20px !important;
  }
  /* Ensure tiles have proper visibility */
  .react-calendar__tile {
    color: #333;
    position: relative;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 6px 4px;
    font-size: 20px !important;
    font-weight: 500 !important;
  }
  /* Hover state for regular tiles (not today) */
  .react-calendar__tile:enabled:hover:not(.react-calendar__tile--now) {
    background-color: #e6e6e6;
  }
  /* Dates with events */
  .react-calendar__tile.has-events {
    background-color: var(--color-secondary-soft);
  }
  .react-calendar__tile.has-events:hover {
    background-color: var(--color-secondary-soft);
  }
`;

const EventTileContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
  max-height: 75px;
  overflow: hidden;
`;

const EventItem = styled.div`
  width: 100%;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  background: ${(props) => {
    if (props.isStart) return "var(--color-secondary)";
    if (props.isEnd) return "var(--color-secondary)";
    if (props.isMultiDay) return "var(--color-secondary)";
    return "var(--color-secondary)";
  }};
  color: white;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease;
  line-height: 1.4;
  ${(props) =>
    props.isStart &&
    props.isMultiDay &&
    `
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `}
  ${(props) =>
    props.isEnd &&
    props.isMultiDay &&
    `
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  `}
  ${(props) =>
    !props.isStart &&
    !props.isEnd &&
    props.isMultiDay &&
    `
    border-radius: 0;
  `}
  &:hover {
    opacity: 0.9;
    transform: scale(1.02);
  }
`;

const EventTitle = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
`;

const EventBar = styled.div`
  width: 100%;
  height: 4px;
  background: var(--color-secondary);
  border-radius: 2px;
`;

const MoreEventsIndicator = styled.div`
  width: 100%;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  background: rgba(49, 119, 140, 0.2);
  color: var(--color-secondary);
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  transition: all 0.2s ease;
  line-height: 1.4;
  &:hover {
    background: rgba(49, 119, 140, 0.3);
  }
`;
